import { render, staticRenderFns } from "./SpellsCard.vue?vue&type=template&id=dd8b38ec&scoped=true&"
import script from "./SpellsCard.vue?vue&type=script&lang=js&"
export * from "./SpellsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8b38ec",
  null
  
)

export default component.exports